import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getBorder, getCssClasses, getIsHidden, getMargin, getPadding, getTextAlign } from '../../utils';
export default (function (node) {
  var iframe = node.querySelector('iframe');
  var video = node.querySelector('video');
  var wrapper = node.querySelector('[data-element="wrapper"]');
  return _objectSpread({
    url: iframe && iframe.getAttribute('src') || video && video.getAttribute('src') || null,
    autoplay: !!(video && video.getAttribute('autoplay') === 'true'),
    muted: !!(video && video.getAttribute('muted') === 'true'),
    maxWidth: node.childNodes[0].style.maxWidth || null
  }, getTextAlign(node), getMargin(node), getBorder(wrapper), getPadding(wrapper), getCssClasses(node), getIsHidden(node));
});